export default "__VITE_ASSET__BtNpvMXJ__"